"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var css_1 = require("./css");
var render_1 = require("./css/render");
exports.buildStyles = render_1.default;
var styler_1 = require("./styler");
exports.createStyler = styler_1.default;
var svg_1 = require("./svg");
var cache = new WeakMap();
var createDOMStyler = function (node, props) {
    var styler = (node instanceof SVGElement) ? svg_1.default(node) : css_1.default(node, props);
    cache.set(node, styler);
    return styler;
};
var getStyler = function (node, props) { return cache.has(node) ? cache.get(node) : createDOMStyler(node, props); };
function default_1(nodeOrSelector, props) {
    var node = (typeof nodeOrSelector === 'string')
        ? document.querySelector(nodeOrSelector)
        : nodeOrSelector;
    return getStyler(node, props);
}
exports.default = default_1;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/stylefire/index.js
// module id = 102
// module chunks = 112359326995148 213534597649335 241203398517478